if($('.customReview').length){
    $(document).ready(function () {
        function customSlider(){
            $('.reviewFeed').slick({
                slidesToShow: 2,
                slidesToScroll: 2,
                centerMode: false,
                autoplay: false,
                autoplaySpeed: 5000,
                dots: true,
                arrows: false,
                infinite: false,
                adaptiveHeight: true,
                responsive: [
                  {
                    breakpoint: 1199,
                    settings: {
                     slidesToShow: 1,
                     slidesToScroll: 1,
                   }
                   
                  } 
                ]
               });
        }
        function mh_remove() {
            $('.customReview .reviewFeed .news-item blockquote').remove();
            $('.customReview .reviewFeed .news-item').each(function() {
                $(this).find('img').attr('src', $(this).attr('data-src'))
                $(this).find('.text').append('<a href="'+$(this).find('.title').attr('href')+'" class="absolutePosition"></a>')
            });
        }
        if (sessionStorage.recenzeFeed) {
            $('.customReview .reviewFeed').append(sessionStorage.recenzeFeed);
            customSlider();
            mh_remove();
            $('.customReview .reviewFeed .news-item').each(function() {
                $(this).find('img').attr('src', $(this).attr('data-src'))
              //  $(this).find('.text').append('<a href="'+$(this).find('.title').attr('href')+'" class="absolutePosition"></a>')
            });
        } else {
            $.ajax({
                type: "GET",
                dataType: "html",
                url: "/recenze-od-nasich-zakaznic/",
                success: function(e) {
                    var a = shoptet.common.createDocumentFromString(e),
                        t = $(a).find(".news-wrapper");
                    if (t) {
                        var newsItems = t.find('.news-item');
                        newsItems.each(function() {
                            var imgElement = $(this).find('img');
                            var dataSrc = imgElement.attr('data-src');
                            if (dataSrc) {
                                imgElement.attr('src', dataSrc);
                            }
                            var linkHref = $(this).find('.title').attr('href');
                            if (linkHref) {
                                $(this).find('.text').append('<a href="' + linkHref + '" class="absolutePosition"></a>');
                            }
                        });
                        $(".customReview .reviewFeed").html(t.html());
                        sessionStorage.recenzeFeed = t.html();
                        mh_remove();
                        customSlider();
                    } else {
                        console.warn('Prvek #newsWrapper není v odpovědi nalezen.');
                    }
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.error('Chyba při načítání blogu:', textStatus, errorThrown);
                },
               
            })
        }
    });    
}